/* eslint-disable eqeqeq, no-redeclare */
import React, { Component } from 'react';
import { AiOutlineRotateRight } from 'react-icons4/ai';
import FaCrop from 'react-icons/lib/fa/crop';
import FaVolumeOff from 'react-icons/lib/fa/volume-off';
import FaVolumeUp from 'react-icons/lib/fa/volume-up';
import PauseIcon from 'react-icons/lib/md/pause';
import PlayIcon from 'react-icons/lib/md/play-arrow';

import { MediaPlayer } from 'dashjs';
import Hls from 'hls.js';

import ClipControls from './ClipControls';
import './videoEditor.css';

class VideoEditor extends Component {
  constructor() {
    super();
    this.state = {
      muted: false,
      cropped: false,
      clipStart: 0,
      clipEnd: 0,
      cropLeft: 0,
      cropRight: 0,
      cropBottom: 0,
      cropTop: 0,
      rotate: 0,
      firstPlay: true,
      showPlayButton: false,
    };

    this.setState = this.setState.bind(this);
    this.mediaError = this.mediaError.bind(this);
    this.videoLoadedData = this.videoLoadedData.bind(this);
    this.videoTimeUpdate = this.videoTimeUpdate.bind(this);
    this.videoEnded = this.videoEnded.bind(this);
    this.onDone = this.onDone.bind(this);
    this.cropControlonPointerDown = this.cropControlonPointerDown.bind(this);
    this.timeChange = this.timeChange.bind(this);

    this.hls = new Hls();
  }

  componentWillMount() {
    this.setState({
      paused: !this.shouldAutoPlay(),
      showPlayButton: !this.shouldAutoPlay(),
    });
    if (this.props.duration) {
      this.gotDuration(this.props.duration);
    }

    if (this.props.durationGuess) {
      this.gotDuration(this.props.durationGuess);
    }
  }

  componentDidMount() {
    this.mounted = true;
    const self = this;

    if (
      !this.props.Player &&
      this.props.mime &&
      this.props.mime.toLowerCase() == 'application/dash+xml'
    ) {
      let player = MediaPlayer().create();
      player.initialize(self.videoRef, self.props.url, true);
    } else if (
      !this.props.Player &&
      this.props.mime &&
      this.props.mime.toLowerCase() === 'application/x-mpegurl'
    ) {
      if (Hls.isSupported()) {
        self.hls = new Hls({
          /*startPosition: 60*/
        });
        self.hls.loadSource(self.props.url);
        self.hls.attachMedia(self.videoRef);
        self.hls.on(Hls.Events.MANIFEST_PARSED, (event, data) => {
          if (this.shouldAutoPlay()) {
            self.play(true);
          }
        });
        /*
        Object.keys(Hls.Events).forEach(function (e) {
          self.hls.on(Hls.Events[e], console.debug.bind(console));
        });
        */
      }
    } else if (this.shouldAutoPlay()) {
      this.play(true);
    }

    window.onresize = function () {
      self.forceUpdate();
    };
    window.onkeyup = function (e) {
      self.onKeyPress(e);
    };

    this.intervalUpdate();
  }

  componentWillUnmount() {
    this.mounted = false;
    this.videoRef = null;
    if (this.hls) {
      console.log('DESTROYING HLS');
      this.hls.destroy();
    }

    window.onresize = null;
    window.onkeyup = null;
    document.body.classList.remove('noscroll');
  }

  onKeyPress(e) {
    if (e.target.nodeName.toLowerCase() == 'input') {
      return;
    }
    if (e.keyCode == 32 || e.keyCode == 75) {
      if (this.videoRef.paused) {
        this.play();
      } else {
        this.pause();
      }
    } else if (e.keyCode == 37 || e.keyCode == 74) {
      if (!this.videoRef.duration) return;
      var time = this.videoRef.currentTime - 1;
      if (time > this.videoRef.duration || time < 0) {
        time = 0;
      }
      this.videoRef.currentTime = time;
    } else if (e.keyCode == 39 || e.keyCode == 76) {
      if (!this.videoRef.duration) return;
      var time = this.videoRef.currentTime + 1;
      if (time > this.videoRef.duration || time < 0) {
        time = 0;
      }
      this.videoRef.currentTime = time;
    } else if (e.keyCode == 73) {
      this.setClipStart(this.videoRef.currentTime);
    } else if (e.keyCode == 79) {
      this.setClipEnd(this.videoRef.currentTime);
    }
  }

  gotDuration(duration) {
    if (!duration) {
      return;
    }
    duration = Number(duration.toFixed(2));

    const update = {
      clipStart: 0,
      duration,
    };
    if (this.props.maxLength && duration > this.props.maxLength) {
      update.clipEnd = this.props.maxLength;
    } else {
      update.clipEnd = duration;
    }
    if (this.props.onDuration) {
      this.props.onDuration(duration);
    }
    this.setState(update);
  }

  intervalUpdate() {
    if (this.videoRef) {
      let time = this.videoRef.currentTime;
      if (time > this.state.clipEnd) {
        time = this.state.clipEnd;
      }

      if (
        this.refs.clipControls &&
        this.refs.clipControls.refs.caretContainer
      ) {
        const margin =
          (time / this.state.duration) *
            this.refs.clipControls.refs.caretContainer.offsetWidth -
          5;
        this.refs.clipControls.refs.caret.style.marginLeft = `${margin}px`;
      }
    }

    if (this.mounted) {
      setTimeout(this.intervalUpdate.bind(this), 50);
    }
  }

  play(firstPlay) {
    const self = this;
    if (!this.mounted) {
      return false;
    }

    const played = () => {
      console.log('played');
      this.setState({
        firstPlay: false,
        paused: false,
        showPlayButton: false,
      });

      setTimeout(() => {
        if (self.videoRef) {
          console.log(self.videoRef.currentTime);
          console.log(self.videoRef.paused);
        }
      }, 1000);
    };

    var promise = this.videoRef.play();
    if (promise !== undefined) {
      promise
        .then((data) => {
          played();
        })
        .catch((error) => {
          console.log("Couldn't play: ", error);
          if (firstPlay) {
            self.setState({ showPlayButton: true, paused: true });
          }
        });
    } else {
      played();
    }

    return true;
  }

  pause() {
    if (!this.mounted) {
      return;
    }
    this.videoRef.pause();
    this.setState({ paused: true });
  }

  mediaError(e) {
    this.props.onPlaybackError({
      url: this.props.source,
      playbackUrl: this.props.url,
      code: e.target.error.code,
      message: e.target.error.message,
    });
  }

  videoLoadedData() {
    const self = this;
    this.gotDuration(this.videoRef.duration);

    setTimeout(() => {
      if (self.props.action == 'crop') {
        self.setState({
          cropped: true,
          cropTop: self.fillerRef.offsetHeight / 6,
          cropBottom: self.fillerRef.offsetHeight / 6,
          cropLeft: self.fillerRef.offsetWidth / 6,
          cropRight: self.fillerRef.offsetWidth / 6,
        });
      } else if (self.props.action == 'mute') {
        self.videoRef.muted = true;
        self.modifyState({ muted: true });
      } else if (this.props.action == 'rotate') {
        self.modifyState({ rotate: 90 });
      }
    }, 0);
  }

  videoEnded() {
    this.videoRef.currentTime = this.state.clipStart;
    this.play();
  }

  videoTimeUpdate() {
    if (!this.videoRef) return;
    if (!this.state.paused) {
      if (
        (this.videoRef.currentTime &&
          this.state.clipEnd &&
          this.videoRef.currentTime >= this.state.clipEnd) ||
        this.videoRef.currentTime >= this.state.duration
      ) {
        console.log('Restarting at 0');
        this.videoRef.currentTime = this.state.clipStart;
        this.play();
      } /*BUGGY IN IOS else if (this.videoRef.currentTime < this.state.clipStart) {
        this.videoRef.currentTime = this.state.clipStart
        this.play();
      }*/
    }
  }

  isFlipped() {
    return this.state.rotate == 90 || this.state.rotate == 270;
  }

  getVideoHeight() {
    return this.videoRef.videoHeight;
  }

  getVideoWidth() {
    return this.videoRef.videoWidth;
  }

  getVideoAspectRatio() {
    return this.getVideoWidth() / this.getVideoHeight();
  }

  getDisplaySize() {
    if (!this.containerRef) {
      return 0;
    }
    const flipped = this.isFlipped();
    const maxWidth = this.containerRef.offsetWidth;
    const maxHeight = 500;

    let height = this.getVideoHeight();
    let width = this.getVideoWidth();

    if (flipped) {
      let oh = height;
      height = width;
      width = oh;
    }

    const ar = this.getDisplayAspectRatio();
    if (width > maxWidth) {
      width = maxWidth;
      height = width / ar;
    }

    if (height > maxHeight) {
      height = maxHeight;
      width = height * ar;
    } else if (height < width && width < maxWidth) {
      height = height * (maxWidth / width);
      width = maxWidth;
    }

    return [height, width];
  }

  getDisplayAspectRatio() {
    return this.isFlipped()
      ? 1 / this.getVideoAspectRatio()
      : this.getVideoAspectRatio();
  }

  onDone(e) {
    let videoScaleRatio;

    const flipped = this.state.rotate == 90 || this.state.rotate == 270;
    const videoHeight = flipped ? this.getVideoWidth() : this.getVideoHeight();
    const videoWidth = flipped ? this.getVideoHeight() : this.getVideoWidth();

    if (
      this.fillerRef.offsetHeight / videoHeight <
      this.fillerRef.offsetWidth / videoWidth
    ) {
      videoScaleRatio = this.fillerRef.offsetHeight / videoHeight;
    } else {
      videoScaleRatio = this.fillerRef.offsetWidth / videoWidth;
    }
    const marginLeft =
      (this.fillerRef.offsetWidth - videoWidth * videoScaleRatio) / 2;
    const marginTop =
      (this.fillerRef.offsetHeight - videoHeight * videoScaleRatio) / 2;

    const params = {
      mute: this.state.muted,
      thumb_offset: this.state.thumbOffset || null,
    };
    if (this.state.clipStart) {
      params.start = this.state.clipStart;
    }
    if (this.state.clipEnd) {
      params.length = this.state.clipEnd - this.state.clipStart;
    }

    if (this.state.rotate) {
      params.rotate = this.state.rotate;
    }

    if (this.state.cropped) {
      const x = Math.round(
        (this.state.cropLeft - marginLeft) * (1 / videoScaleRatio)
      );
      const y = Math.round(
        (this.state.cropTop - marginTop) * (1 / videoScaleRatio)
      );
      if (x !== null && y !== null) {
        let width = Math.round(
          (this.fillerRef.offsetWidth -
            this.state.cropLeft -
            this.state.cropRight) *
            (1 / videoScaleRatio)
        );
        if (width > videoWidth - x) {
          width = videoWidth - x;
        }
        let height = Math.round(
          (this.fillerRef.offsetHeight -
            this.state.cropTop -
            this.state.cropBottom) *
            (1 / videoScaleRatio)
        );
        if (height > videoHeight - y) {
          height = videoHeight - y;
        }
        if (height && width) {
          params.crop = { width, height, x: x < 0 ? 0 : x, y: y < 0 ? 0 : y };
        }
      }
    }

    this.props.onFinish(params);
  }

  modifyState(data) {
    this.modified = true;
    this.setState(data);
  }

  cropControlonPointerDown(e) {
    const self = this;
    const startPageX = e.pageX;
    const startPageY = e.pageY;
    const elem = e.target;
    const startTop = this.state.cropTop;
    const startLeft = this.state.cropLeft;
    const startBottom = this.state.cropBottom;
    const startRight = this.state.cropRight;

    document.body.classList.add('noscroll');

    const onPointerMove = (e) => {
      const deltaX = e.pageX - startPageX;
      const deltaY = e.pageY - startPageY;

      let cropTop = startTop + deltaY;
      if (cropTop < 0) {
        cropTop = 0;
      }
      let cropLeft = startLeft + deltaX;
      if (cropLeft < 0) {
        cropLeft = 0;
      }
      let cropRight = startRight - deltaX;
      if (cropRight < 0) {
        cropRight = 0;
      }
      let cropBottom = startBottom - deltaY;
      if (cropBottom < 0) {
        cropBottom = 0;
      }

      if (elem.id === 'upper-left') {
        if (cropTop > self.fillerRef.offsetHeight - startBottom - 50) {
          cropTop = self.fillerRef.offsetHeight - startBottom - 50;
        }
        if (cropLeft > self.fillerRef.offsetWidth - startRight - 50) {
          cropLeft = self.fillerRef.offsetWidth - startRight - 50;
        }

        self.modifyState({ cropTop });
        self.modifyState({ cropLeft });
      } else if (elem.id === 'upper-right') {
        if (cropTop > self.fillerRef.offsetHeight - startBottom - 50) {
          cropTop = self.fillerRef.offsetHeight - startBottom - 50;
        }
        if (
          self.state.cropRight >
          self.fillerRef.offsetWidth - startLeft - 50
        ) {
          cropRight = self.fillerRef.offsetWidth - startLeft - 50;
        }

        self.modifyState({ cropTop });
        self.modifyState({ cropRight });
      } else if (elem.id === 'bottom-left') {
        if (cropBottom > self.fillerRef.offsetHeight - startTop - 50) {
          cropBottom = self.fillerRef.offsetHeight - startTop - 50;
        }
        if (cropLeft > self.fillerRef.offsetWidth - startRight - 50) {
          cropLeft = self.fillerRef.offsetWidth - startRight - 50;
        }

        self.modifyState({ cropBottom });
        self.modifyState({ cropLeft });
      } else if (elem.id === 'bottom-right') {
        if (cropBottom > self.fillerRef.offsetHeight - startTop - 50) {
          cropBottom = self.fillerRef.offsetHeight - startTop - 50;
        }
        if (cropRight > self.fillerRef.offsetWidth - startLeft - 50) {
          cropRight = self.fillerRef.offsetWidth - startLeft - 50;
        }

        self.setState({ cropBottom });
        self.setState({ cropRight });
      } else if (elem.id === 'right') {
        if (cropRight > self.fillerRef.offsetWidth - startLeft - 50) {
          cropRight = self.fillerRef.offsetWidth - startLeft - 50;
        }
        self.setState({ cropRight });
      } else if (elem.id === 'left') {
        if (cropLeft > self.fillerRef.offsetWidth - startRight - 50) {
          cropLeft = self.fillerRef.offsetWidth - startRight - 50;
        }
        self.setState({ cropLeft });
      } else if (elem.id === 'top') {
        if (cropTop > self.fillerRef.offsetHeight - startBottom - 50) {
          cropTop = self.fillerRef.offsetHeight - startBottom - 50;
        }
        self.setState({ cropTop });
      } else if (elem.id === 'bottom') {
        if (cropBottom > self.fillerRef.offsetHeight - startTop - 50) {
          cropBottom = self.fillerRef.offsetHeight - startTop - 50;
        }
        self.setState({ cropBottom });
      }
    };

    const onPointerUp = () => {
      document.documentElement.removeEventListener(
        'pointermove',
        onPointerMove
      );
      document.documentElement.removeEventListener('pointerup', onPointerUp);
      document.body.classList.remove('noscroll');
    };

    document.documentElement.addEventListener('pointermove', onPointerMove);
    document.documentElement.addEventListener('pointerup', onPointerUp);
  }

  timeChange(id, value) {
    if (id === 'start') {
      this.modifyState({ clipStart: value });
    } else if (id === 'end') {
      this.modifyState({ clipEnd: value });
    }
  }

  shouldAutoPlay() {
    return this.props.autoPlay;
  }

  setClipStart(value) {
    if (value >= this.state.clipEnd) {
      return;
    }

    const tooLong = this.props.maxLength
      ? this.state.clipEnd - value > this.props.maxLength
      : false;
    this.modifyState({ tooLong });
    this.modifyState({
      clipStart: value,
    });

    if (value > this.state.thumbOffset) {
      this.modifyState({ thumbOffset: value });
    }

    console.log('setting current time (clip controls)');
    this.videoRef.currentTime = value;
  }

  setClipEnd(value) {
    if (value <= this.state.clipStart) {
      return;
    }

    const tooLong = this.props.maxLength
      ? value - this.state.clipStart > this.props.maxLength
      : false;
    this.modifyState({ tooLong });
    this.modifyState({
      clipEnd: value,
    });

    if (value < this.state.thumbOffset) {
      this.modifyState({ thumbOffset: value });
    }

    this.videoRef.currentTime = value;
  }

  render() {
    const self = this;
    const url =
      this.props.mime &&
      this.props.mime.toLowerCase() === 'application/x-mpegurl'
        ? ''
        : this.props.url;

    const displaySize = this.getDisplaySize();
    const height = displaySize[0];
    const width = displaySize[1];
    const maxSize = height > width ? height : width;

    const playerAttributes = {
      playsInline: true,
      autoPlay: this.shouldAutoPlay(),
      id: 'media',
      width: '100%',
      height: '100%',
      preload: 'metadata',
      ref: (r) => {
        if (r) {
          this.videoRef = r;
        }
      },
      poster: this.props.poster,
      onEnded: this.videoEnded,
      onError: this.mediaError,
      onLoadedData: this.videoLoadedData,
      onTimeUpdate: this.videoTimeUpdate,
      onContextMenu: (e) => {
        e.preventDefault();
        return false;
      },
      'data-streamable-noclip': true,
      src: url,
      onClick: (e) => {
        if (this.state.paused || this.forcePlay) {
          this.play();
        } else {
          this.pause();
        }
      },
    };

    return (
      <div
        className={`videoeditor ${
          this.state.rotate ? `rotate${this.state.rotate}` : ''
        } ${this.isFlipped() ? 'flipped' : ''}`}
      >
        <div
          className="clip-player-container"
          style={{
            top: width > height ? (width - height) / -2 + 'px' : 0,
            left: this.containerRef
              ? maxSize > this.containerRef.offsetWidth
                ? (maxSize - this.containerRef.offsetWidth) / -2 + 'px'
                : 0
              : 0,
            transform: this.state.rotate
              ? `rotate(${this.state.rotate}deg)`
              : null,
            display: height ? 'block' : 'none',
            height: maxSize + 'px',
            width: maxSize + 'px',
          }}
        >
          {this.props.Player ? (
            <this.props.Player
              {...{
                ...playerAttributes,
                videoId: this.props.videoId,
                videoHeight: this.props.videoHeight,
                videoWidth: this.props.videoWidth,
              }}
            />
          ) : (
            <video {...playerAttributes} />
          )}
        </div>
        <div className="clip-preview" ref={(r) => (this.containerRef = r)}>
          <div
            className="filler"
            ref={(r) => (this.fillerRef = r)}
            style={{
              width: width + 'px',
              height: height + 'px',
            }}
          >
            {this.state.paused && !this.state.showPlayButton ? (
              <div className="play-control">
                <PauseIcon />
              </div>
            ) : (
              ''
            )}

            {this.state.cropped ? (
              <div
                className="clip-crop-controls"
                style={{
                  height: this.fillerRef.offsetHeight,
                  width: this.fillerRef.offsetWidth,
                  left: 0,
                  top: 0,
                  position: 'absolute',
                }}
              >
                <div
                  className="clip-crop-shade"
                  id="left"
                  style={{
                    right: `${
                      this.fillerRef.offsetWidth - this.state.cropLeft
                    }px`,
                  }}
                />
                <div
                  className="clip-crop-shade"
                  id="right"
                  style={{
                    left: `${
                      this.fillerRef.offsetWidth - this.state.cropRight
                    }px`,
                  }}
                />
                <div
                  className="clip-crop-shade"
                  id="top"
                  style={{
                    left: `${this.state.cropLeft}px`,
                    right: `${this.state.cropRight}px`,
                    bottom: `${
                      this.fillerRef.offsetHeight - this.state.cropTop
                    }px`,
                  }}
                />
                <div
                  className="clip-crop-shade"
                  id="bottom"
                  style={{
                    left: `${this.state.cropLeft}px`,
                    right: `${this.state.cropRight}px`,
                    top: `${
                      this.fillerRef.offsetHeight - this.state.cropBottom
                    }px`,
                  }}
                />
                <div
                  className="clip-crop-control"
                  id="upper-left"
                  style={{
                    top: `${this.state.cropTop - 2}px`,
                    bottom: `${
                      this.fillerRef.offsetHeight - this.state.cropTop - 22
                    }px`,
                    left: `${this.state.cropLeft - 2}px`,
                    right: `${
                      this.fillerRef.offsetWidth - this.state.cropLeft - 22
                    }px`,
                  }}
                  onPointerDown={this.cropControlonPointerDown}
                />
                <div
                  className="clip-crop-control"
                  id="upper-right"
                  style={{
                    top: `${this.state.cropTop - 2}px`,
                    bottom: `${
                      this.fillerRef.offsetHeight - this.state.cropTop - 22
                    }px`,
                    left: `${
                      this.fillerRef.offsetWidth - this.state.cropRight - 22
                    }px`,
                    right: `${this.state.cropRight - 2}px`,
                  }}
                  onPointerDown={this.cropControlonPointerDown}
                />
                <div
                  className="clip-crop-control"
                  id="bottom-left"
                  style={{
                    top: `${
                      this.fillerRef.offsetHeight - this.state.cropBottom - 22
                    }px`,
                    bottom: `${this.state.cropBottom - 2}px`,
                    left: `${this.state.cropLeft - 2}px`,
                    right: `${
                      this.fillerRef.offsetWidth - this.state.cropLeft - 22
                    }px`,
                  }}
                  onPointerDown={this.cropControlonPointerDown}
                />
                <div
                  className="clip-crop-control"
                  id="bottom-right"
                  style={{
                    top: `${
                      this.fillerRef.offsetHeight - this.state.cropBottom - 22
                    }px`,
                    bottom: `${this.state.cropBottom - 2}px`,
                    left: `${
                      this.fillerRef.offsetWidth - this.state.cropRight - 22
                    }px`,
                    right: `${this.state.cropRight - 2}px`,
                  }}
                  onPointerDown={this.cropControlonPointerDown}
                />
                <div
                  className="clip-crop-control"
                  id="right"
                  style={{
                    top: `${
                      this.state.cropTop +
                      (this.fillerRef.offsetHeight -
                        this.state.cropTop -
                        this.state.cropBottom) /
                        2 -
                      15
                    }px`,
                    bottom: `${
                      this.state.cropBottom +
                      (this.fillerRef.offsetHeight -
                        this.state.cropTop -
                        this.state.cropBottom) /
                        2 -
                      15
                    }px`,
                    left: `${
                      this.fillerRef.offsetWidth - this.state.cropRight - 15
                    }px`,
                    right: `${this.state.cropRight - 2}px`,
                  }}
                  onPointerDown={this.cropControlonPointerDown}
                />
                <div
                  className="clip-crop-control"
                  id="left"
                  style={{
                    top: `${
                      this.state.cropTop +
                      (this.fillerRef.offsetHeight -
                        this.state.cropTop -
                        this.state.cropBottom) /
                        2 -
                      15
                    }px`,
                    bottom: `${
                      this.state.cropBottom +
                      (this.fillerRef.offsetHeight -
                        this.state.cropTop -
                        this.state.cropBottom) /
                        2 -
                      15
                    }px`,
                    left: `${this.state.cropLeft - 2}px`,
                    right: `${
                      this.fillerRef.offsetWidth - this.state.cropLeft - 15
                    }px`,
                  }}
                  onPointerDown={this.cropControlonPointerDown}
                />
                <div
                  className="clip-crop-control"
                  id="top"
                  style={{
                    left: `${
                      this.state.cropLeft +
                      (this.fillerRef.offsetWidth -
                        this.state.cropLeft -
                        this.state.cropRight) /
                        2 -
                      15
                    }px`,
                    right: `${
                      this.state.cropRight +
                      (this.fillerRef.offsetWidth -
                        this.state.cropLeft -
                        this.state.cropRight) /
                        2 -
                      15
                    }px`,
                    top: `${this.state.cropTop - 2}px`,
                    bottom: `${
                      this.fillerRef.offsetHeight - this.state.cropTop - 15
                    }px`,
                  }}
                  onPointerDown={this.cropControlonPointerDown}
                />
                <div
                  className="clip-crop-control"
                  id="bottom"
                  style={{
                    left: `${
                      this.state.cropLeft +
                      (this.fillerRef.offsetWidth -
                        this.state.cropLeft -
                        this.state.cropRight) /
                        2 -
                      15
                    }px`,
                    right: `${
                      this.state.cropRight +
                      (this.fillerRef.offsetWidth -
                        this.state.cropLeft -
                        this.state.cropRight) /
                        2 -
                      15
                    }px`,
                    bottom: `${this.state.cropBottom - 2}px`,
                    top: `${
                      this.fillerRef.offsetHeight - this.state.cropBottom - 15
                    }px`,
                  }}
                  onPointerDown={this.cropControlonPointerDown}
                />
              </div>
            ) : (
              ''
            )}
          </div>
          {!this.props.Player && this.state.showPlayButton ? (
            <div
              className="play-button"
              onClick={() => {
                this.play();
                this.setState({ showPlayButton: false });
              }}
            >
              <PlayIcon />
            </div>
          ) : (
            ''
          )}
        </div>
        <div id="clip-controls" className="card">
          {this.state.duration ? (
            <ClipControls
              ref="clipControls"
              mobile={this.props.mobile}
              tooLong={false}
              clipStart={this.state.clipStart}
              clipEnd={this.state.clipEnd}
              duration={this.state.duration}
              paused={this.state.paused}
              onStartChange={(value, blur) => {
                if (value === null) {
                  value = this.videoRef.currentTime;
                }

                this.setClipStart(value);

                if (blur) {
                  this.forcePlay = true;
                  setTimeout(() => {
                    self.forcePlay = false;
                  }, 100);
                  this.play();
                } else {
                  this.pause();
                }
              }}
              onEndChange={(value, blur) => {
                if (value === null) {
                  value = this.videoRef.currentTime;
                }

                this.setClipEnd(value);

                if (blur) {
                  this.forcePlay = true;
                  setTimeout(() => {
                    self.forcePlay = false;
                  }, 100);
                  this.play();
                } else {
                  this.pause();
                }
              }}
              onAfterChange={() => {
                console.log('playing (onAfterChange)');
                this.play();
              }}
              onScrubStart={(value) => {
                if (value < this.state.clipStart) return;
                if (value > this.state.clipEnd) return;

                this.pause();
                console.log('pausing - setting current time (scrubStart)');
                this.videoRef.currentTime = value;
              }}
              onScrub={(value) => {
                if (value < this.state.clipStart) return;
                if (value > this.state.clipEnd) return;

                console.log('setting current time (onScrub)');
                this.videoRef.currentTime = value;
              }}
              onScrubEnd={(value) => {
                console.log('playing (onScrubEnd)');
                this.play();
              }}
            />
          ) : (
            ''
          )}
          <div id="clip-controls-footer">
            {!this.props.noAudio ? (
              <button
                id="mute"
                className={
                  this.state.muted
                    ? 'clipper-tool clipper-tool-button selected'
                    : 'clipper-tool clipper-tool-button'
                }
                onClick={(e) => {
                  this.videoRef.muted = !this.state.muted;
                  this.modifyState({ muted: !this.state.muted });
                }}
              >
                {this.state.muted ? (
                  <span>
                    <FaVolumeOff /> Sound Off
                  </span>
                ) : (
                  <span>
                    <FaVolumeUp /> Sound On
                  </span>
                )}
              </button>
            ) : (
              ''
            )}
            <button
              id="crop"
              className={
                this.state.cropped
                  ? 'clipper-tool clipper-tool-button selected'
                  : 'clipper-tool clipper-tool-button'
              }
              onClick={(e) => {
                this.modifyState({
                  cropped: !this.state.cropped,
                  cropTop: this.fillerRef.offsetHeight / 6,
                  cropBottom: this.fillerRef.offsetHeight / 6,
                  cropLeft: this.fillerRef.offsetWidth / 6,
                  cropRight: this.fillerRef.offsetWidth / 6,
                });
              }}
            >
              {this.state.cropped ? (
                <span className="crop-icon">
                  <FaCrop /> Remove Crop
                </span>
              ) : (
                <span className="crop-icon">
                  <FaCrop /> Crop
                </span>
              )}
            </button>
            <button
              id="rotate"
              className="clipper-tool clipper-tool-button"
              onClick={(e) => {
                this.modifyState({
                  rotate: this.state.rotate >= 270 ? 0 : this.state.rotate + 90,
                });
                if (this.state.cropped) {
                  setTimeout(() => this.forceUpdate()); // this is necessary so that the crop can realign off new sizing
                }
              }}
            >
              <span className="rotate-icon">
                <AiOutlineRotateRight /> Rotate
              </span>
            </button>
            <button
              className="done-button blue-button"
              onClick={this.onDone}
              disabled={!this.state.duration}
            >
              {this.props.doneButtonText}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default VideoEditor;
